import React from "react"
import styled from "styled-components"
import {
  DropdownSection,
  DropdownItem,
  DropdownList,
  Label
} from "./Components"

import AboutLogo from '../svg/About'
import EventsLogo from '../svg/Events'
import CareersLogo from '../svg/Careers'

const CompanyDropdownEl = styled.div`
  width: 220px;
  font-size: 16px;
`

const CompanyDropdown = () => {
  return (
    <CompanyDropdownEl>
      <DropdownSection data-first-dropdown-section>
        <DropdownItem
          logo={<AboutLogo size={32} />}
          title="About Us"
          href="/about"
          color="blue"
          marginBottom={28}
        />
        <DropdownItem
          logo={<EventsLogo size={32} />}
          title="Events"
          href="/events"
          color="blue"
          marginBottom={28}
        />
        <DropdownItem
          logo={<CareersLogo size={32} />}
          title="Careers"
          href="/careers"
          color="blue"
          marginBottom={28}
        />
      </DropdownSection>
      <DropdownSection>
        <DropdownList>
          <li>
            <Label>More Links</Label>
          </li>
          <li><a href="/about/fossa-loves-open-source">We ♥ OSS</a></li>
          <li><a href="https://tldrlegal.com">TLDRLegal</a></li>
          <li><a href="https://demand.fossa.com/contact-me?source=Website">Contact Us</a></li>
        </DropdownList>
      </DropdownSection>
    </CompanyDropdownEl>
  )
}

export default CompanyDropdown
